// Design System
import env from 'jl-design-system/utils/env/env';

// Types
import { SelectOption } from 'types/App.types';
import { RootState } from 'types/RootState.types';
import {
  GooglePayStubConfig,
  StubDataProps,
} from '@non-prod-utils/components/payment-wallet-stubs/PaymentWalletStubs.types';

// Config
import { isStripeCheckoutEnabledFeatureActive } from '@redux/reducers/config/configSelector';

function getSelectOptions(data: GooglePayStubConfig): SelectOption[] {
  const stubs = data?.stubs ?? {};

  return Object.keys(stubs).map((key) => ({
    label: `Stub : ${key}`,
    value: key,
  }));
}

export default async function loadPaymentWalletStubs(stubName: string): Promise<StubDataProps | null> {
  const stubsResponse = await window.fetch(window.env.MOCKDATA_LOCATION).catch(() => {
    // eslint-disable-next-line no-console
    console.warn('Can not load mockData.json - stubs will not work');
  });

  if (!stubsResponse) {
    return null;
  }

  const jsonStubsResponse = await stubsResponse.json();
  const mockData = jsonStubsResponse[stubName];
  const options = getSelectOptions(mockData);
  const firstOption = options?.[0];
  const payload = mockData?.stubs?.[firstOption?.value];

  return {
    mockData,
    stub: firstOption.label,
    options,
    payload,
  };
}

export function shouldLoadPaymentWalletStubs(state: RootState) {
  const stripeCheckoutFlowEnabledSelector = isStripeCheckoutEnabledFeatureActive(state);

  return (
    !stripeCheckoutFlowEnabledSelector && env.isClientNonProd && state?.payment?.applePayCompatibilityChecksComplete
  );
}
